/*
|--------------------------------------------------------------------------
|
| 这些组件暴露给使用方
|
|--------------------------------------------------------------------------
*/
import HelloWorld from './HelloWorld.vue'

export default {
  HelloWorld
}
